import React, { useEffect } from 'react';

import { Icon, Logo, Text } from '@betterment/samba-react';
import { getLegacySearchParam } from '@betterment/shared-components';
import { CenteredWorkflowLayout, Heading, WorkflowHeader } from '@betterment/style-closet-react';
import { useSearchParams } from 'react-router-dom';

import { useAccount } from './AccountProvider';
import SudoRouteComponent from './SudoRouteComponent';

import Footer from '../../Shared/components/Footer';
import { locationAssign } from '../../Shared/path-helpers';
import { urlBuilder } from '../../Shared/urlBuilder';

const LogoSymbol: React.FC = () => <Logo type="symbol" css={{ height: 'size.400', width: 'size.400' }} />;

const AuthorizedTransactionExport = () => {
  const { account } = useAccount();
  const [searchParams] = useSearchParams();
  const transactionExportId = getLegacySearchParam(searchParams, 'transaction_export_id');

  useEffect(() => {
    if (transactionExportId) {
      locationAssign(urlBuilder.getDetailedTransactionExport(account.id, transactionExportId));
    }
  }, [account.id, transactionExportId]);

  return (
    <CenteredWorkflowLayout>
      <CenteredWorkflowLayout.Slot name="header">
        <WorkflowHeader
          logo={LogoSymbol}
          logoHandler={() => locationAssign(urlBuilder.getAppCheckingSummary.absolute({ accountId: account.id }))}
          title=""
          closeHandler={() => locationAssign(urlBuilder.getAppCheckingSummary.absolute({ accountId: account.id }))}
        />
      </CenteredWorkflowLayout.Slot>
      <CenteredWorkflowLayout.Slot name="content">
        <Icon name="Download" size="large" />
        <Heading mt="7" pb="2" variant="primary">
          Downloading your Checking transactions
        </Heading>
        <Text>If the download doesn't start automatically, please try again from your email.</Text>
      </CenteredWorkflowLayout.Slot>
      <CenteredWorkflowLayout.Slot name="footer">
        <Footer />
      </CenteredWorkflowLayout.Slot>
    </CenteredWorkflowLayout>
  );
};

const TransactionExport: React.FC = () => {
  return (
    <SudoRouteComponent exitTo={urlBuilder.appHome.absolute()}>
      <AuthorizedTransactionExport />
    </SudoRouteComponent>
  );
};

export default TransactionExport;
